import sensors from 'sa-sdk-javascript';

const server_url = 'https://xlm-sc.xlsuixing.com/sa?project=';

const isProd =
  window.location.href.indexOf('xlm-app-web.xlsuixing.com') > -1 ||
  window.location.href.indexOf('xlm-web.xlmclub.com') > -1;

sensors.init({
  server_url: isProd ? server_url + 'xlm' : server_url + 'xlm_test',
  //heatmap_url神策分析中点击分析及触达分析功能代码，代码生成工具会自动生成。如果神策代码中 `sensorsdata.min.js` 版本是 1.9.1 及以上版本，这个参数必须配置，低于此版本不需要配置。
  heatmap_url: 'https://www.xlmclub.com/xlm_ad/xlm-static/assets/js/lib/sensorsdata.min.js',
  //web_url 神策分析中点击分析及触达分析功能会用到此地址，代码生成工具会自动生成。如果神策后台版本及 `sensorsdata.min.js` 均是 1.10 及以上版本，这个参数不需要配置。
  web_url: '神策分析后台地址',
  heatmap: {
    //是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
    //需要 JSSDK 版本号大于 1.7
    clickmap: 'default',
    //是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
    //需要 JSSDK 版本号大于 1.9.1
    scroll_notice_map: 'not_collect',
  },
});

export const sensorsQuick = () => {
  sensors.quick('autoTrackSinglePage');
};

export const sensorsLogin = user_id => {
  sensors.login(user_id);
};

export const registerPage = params => {
  sensors.registerPage(params);
};

export const sensorsTrack = (eventKey, params) => {
  try {
    console.log('神策埋点', eventKey, params);
    sensors.track(eventKey, params);
  } catch (e) {
    console.error(e);
  }
};
